import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function isUndefined<T>(
	value: T | null | undefined,
): value is null | undefined {
	return value === undefined || value === null;
}

export const snakeCase = (str: string): string => {
	return str
		.replace(/\W+/g, " ")
		.split(/ |\B(?=[A-Z])/)
		.map((word) => word.toLowerCase())
		.join("_");
};

export const capitalize = (str: string): string => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const emojiLabelSplicer = (
	label: string,
	hideEmoji = false,
): [emoji: string, text: string] => {
	const [emoji, text] = label.split(" ").slice(0, 2);

	if (hideEmoji) {
		return ["", text];
	}

	return [emoji, text];
};
